import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

const HomeIcon = (props) => (
  <Svg
    width={45}
    height={45}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G fill={props.color}>
      <Path fill={props.color} d="m42.138 21.613-18.75-18.75a1.25 1.25 0 0 0-1.763 0l-18.75 18.75a1.25 1.25 0 0 0 1.762 1.762L22.5 5.513l17.862 17.874a1.25 1.25 0 0 0 1.763-1.762l.013-.012Z" />
      <Path fill={props.color} d="M35 40h-6.25V27.5h-12.5V40H10V22.5L7.5 25v15a2.5 2.5 0 0 0 2.5 2.5h8.75V30h7.5v12.5H35a2.5 2.5 0 0 0 2.5-2.5V24.7L35 22.2V40Z" />
    </G>
    
  </Svg>
);
HomeIcon.defaultProps = {
  color: "#fff",
};
export default HomeIcon;
